import React, { useEffect } from "react";
import "../styles/nav.sass";
import logo from "../img/logo.webp";
import { useNavigate } from "react-router-dom";

const PcNav = ({ navNames }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLinkClick = (section, offset = 0) => {
    navigate("/", { replace: true });

    setTimeout(() => {
      const element = document.querySelector(`.${section}`);
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition + offset,
          behavior: "smooth",
        });
      }
    }, 100);
  };

  const handleLogoClick = () => {
    navigate("/", { replace: true });
  };

  return (
    <nav>
      <div className='pc_nav'>
        <p onClick={() => handleLinkClick(navNames[0].to, -100)}>
          {navNames[0].name}
        </p>

        <p onClick={() => handleLinkClick(navNames[1].to, -100)}>
          {navNames[1].name}
        </p>

        <img src={logo} onClick={handleLogoClick} alt='Logo' />

        <p onClick={() => handleLinkClick(navNames[2].to, -100)}>
          {navNames[2].name}
        </p>

        <p onClick={() => handleLinkClick(navNames[3].to, -100)}>
          {navNames[3].name}
        </p>
      </div>
    </nav>
  );
};

export default PcNav;
